import { render, staticRenderFns } from "./Route.vue?vue&type=template&id=1a56bbe7&scoped=true&"
import script from "./Route.vue?vue&type=script&lang=js&"
export * from "./Route.vue?vue&type=script&lang=js&"
import style0 from "./Route.vue?vue&type=style&index=0&id=1a56bbe7&prod&lang=css&"
import style1 from "./Route.vue?vue&type=style&index=1&id=1a56bbe7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a56bbe7",
  null
  
)

export default component.exports